import React, { useState, useEffect, useMemo } from 'react';
import { Grid2 } from '@mui/material';
import { useGetTicketSeats } from '@openapi/ticket-seats/ticket-seats';
import SeatDetails from './SeatDetails';
import mapFromDbToElement from '../../seats/helpers/mapFromDbToElement';
import SvgViewer from '../../../components/svgeditor/SvgViewer';
import { useArrangementElements } from '../../../hooks/useArrangementElements';

function SeatViewer({
    elements,
    setElements,
    selectedElementId,
    setSelectedElementId,
    showId,
    timeslotId,
    data,
    ticketTypeColorMap,
}) {
    const [selectedData, setSelectedData] = useState(
        data?.find((el) => el.id === selectedElementId),
    );

    const { data: seatData, isLoading: seatLoading } = useGetTicketSeats(showId, {
        pageSize: 10000,
        page: 0,
    });

    useEffect(() => {
        if (!seatData) {
            return;
        }
        // need to be another mapFromDbToElement for cateringview, because the stroke color is different
        setElements(seatData?.ticketSeats.map(mapFromDbToElement));
    }, [seatData, seatLoading, setElements]);

    // Create a color map object from the booking data and ticket type colors
    const colorMap = useMemo(() => {
        if (!elements || !data) return {};

        const map = {};
        elements.forEach((element) => {
            // Find the booking for this seat
            const booking = data.find((item) => item.ticketSeatId === element.id);

            // Determine color based on booking status
            if (!element.bookable) {
                map[element.id] = '#eeeeee'; // non-bookable seats
            } else if (!booking) {
                map[element.id] = 'transparent'; // available seats
            } else {
                // Use ticket type color from the map
                map[element.id] = ticketTypeColorMap[booking.ticketTypeId] || '#000000';
            }
        });
        return map;
    }, [elements, data, ticketTypeColorMap]);

    const { displayElements } = useArrangementElements(showId, elements, timeslotId);

    return (
        <Grid2 size={{ xs: 12 }}>
            <div style={{ position: 'relative', height: '600px', border: '1px solid #ccc' }}>
                <SvgViewer
                    elements={displayElements}
                    colorMap={colorMap}
                    onClickElement={(id) => {
                        setSelectedElementId(id);
                        setSelectedData(data?.find((el) => el.ticketSeatId === id));
                    }}
                    inCartSeatIds={[selectedElementId]}
                >
                    {selectedElementId && (
                        <SeatDetails
                            selectedElement={elements.find((el) => el.id === selectedElementId)}
                            selectedData={selectedData}
                            onClose={() => setSelectedElementId(null)}
                        />
                    )}
                </SvgViewer>
            </div>
        </Grid2>
    );
}

export default SeatViewer;
